export default "__VITE_ASSET__B_KvQRT6__"